export const isDebugMode = (selector: string): boolean => {
  const el: Element | null = document.querySelector(selector)
  if (el) {
    const enabled: string | null = el.getAttribute('data-debug')
    const isEnabled: boolean = (enabled === 'enabled')
    if (isEnabled) {
      console.log('%cDebug mode is enabled.', 'color: #F59E0B;')
      return true
    }
  }
  return false
}
